import { render } from "./AdminLayout.vue?vue&type=template&id=80d1ff56&scoped=true"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"

import "./AdminLayout.vue?vue&type=style&index=0&id=80d1ff56&lang=scss&scoped=true"
import "./AdminLayout.vue?vue&type=style&index=1&id=80d1ff56&lang=scss"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80d1ff56"]])

export default __exports__